const sh = require('shelljs')
const axios = require('axios')

function bounce(yargs) {

    console.log("ops bounce -- ")

    // somehow get login credentials
    const username = "blah"
    const password = "something"
    const ACTIVE_STACK = 'a'
    const SLACKHOST = 'leiopsdev'
    const SLACK_WEBHOOK_URL =  'https://hooks.slack.com/services/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'
    const BOUNCE_START_MESSAGE = "Bouncing..." // users should be able to customize these
    const BOUNCE_END_MESSAGE = "Bounced."
    // can you post a giphy using webhooks?
    // can I add emoji support?
    const getUrl = stack => `sbxwebservices${stack}.sbx.avtr.net`
    const url = getUrl(ACTIVE_STACK)
    // Tell slack the bounce will start
    _onBounceStart()

    // ssh to the active stack and stop wildfly
    sh.exec(`ssh ${url} "sudo service wildfly stop"`)

    // make sure it actually stopped
    sh.exec(`ssh ${url} "ps aux | grep jboss"`)

    // ensure the following DOES NOT show up
    /*
        gaia     15435  212 36.6 8496904 2995424 pts/4 Sl   12:06   2:09 java -D[Standalone] -server -Xms1024m -Xmx4096m -Djboss.server.log.dir=/opt/lei/gaia/logs -agentpath:/usr/share/wildfly/yjp/bin/linux-x86-64/libyjpagent.so=delay=10000,dir=/usr/share/wildfly/yjp/snapshots,logdir=/usr/share/wildfly/yjp/logs -Dorg.jboss.boot.log.file=/varfs/log/webservices/sbx-webservices-03/server.log -Dlogging.configuration=file:/usr/share/wildfly/standalone/configuration/logging.properties -jar /usr/share/wildfly/jboss-modules.jar -mp /usr/share/wildfly/modules org.jboss.as.standalone -Djboss.home.dir=/usr/share/wildfly -Djboss.server.base.dir=/usr/share/wildfly/standalone -b 0.0.0.0 -bmanagement 0.0.0.0 -c standalone.xml -Djava.rmi.server.hostname=172.17.110.29
    */




    // tail /opt/lei/gaia/logs/server.log until this shows up
    const SUCCESS_MATCH = ") started in "
    sh.exec(
        `ssh ${url} tail -f /opt/lei/gaia/logs/server.log | while read LOGLINE
        do
           [[ "\${LOGLINE}" == *"${SUCCESS_MATCH}"* ]] && pkill -P $$ tail
        done`
    )

    // run sudo wildfly start
    sh.exec(`ssh ${url} "sudo service wildfly start"`)

    /*

        2017-11-06 17:03:50,917 INFO  [org.jboss.as] (Controller Boot Thread) WFLYSRV0025: WildFly Full 10.0.0.Final (WildFly Core 2.0.10.Final) started in 39643ms - Started 2211 of 2542 services (578 services are lazy, passive or on-demand)
        2017-11-06 17:03:52,704 INFO  [org.hibernate.jpa.internal.util.LogHelper] (default task-1) HHH000204: Processing PersistenceUnitInfo [
        	name: userSettings
    	...]

        the regex should be something like

        /started in *ms - Started * of * services/

    */

    // notify slack "bounced"
    _onBounceEnd()

    // or time out after two minutes
    console.log("wildfly did not restart")

}

function _onBounceStart() {
    axios.post(SLACK_WEBHOOK_URL, {
        channel: "#general",
        username: "opsbot",
        icon_emoji: ":robot_face:",
        text: BOUNCE_START_MESSAGE
    })
}

function _onBounceEnd() {

    console.log("done")

    axios.post(SLACK_WEBHOOK_URL, {
        channel: "#general",
        username: "opsbot",
        icon_emoji: ":robot_face:",
        text: BOUNCE_END_MESSAGE
    })
}

module.exports = bounce



// WEBPACK FOOTER //
// ./src/commands/bounce.js